<template>
    <transition name="fade">
        <div class="modal" :class="{'show':modal_show}" tabindex="-1" aria-hidden="true" v-if="modal_show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}} Topic</h5>
                        <button type="button" class="btn btn-round close" @click="close">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                    <div class="modal-body p-3">
                        <div class="form-group m-0">
                            <input type="text" class="form-control form-control-lg custom-input" ref="input" :value="data.data" placeholder="Enter here..."/>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn text-primary" @click="exec">{{title}}</button>
                        <button type="button" class="btn" @click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            modal_show: false,
            data: '',
        }
    },
    computed: {
        title() {
            return (this.data.hasOwnProperty.call(this.data, 'data') == '' ? 'Add' : 'Update');
        }
    },
    methods: {
        close() {
            this.modal_show = false;
            this.data = '';
        },
        exec() {
            if(typeof this.data !== 'object') return;

            if(this.data.hasOwnProperty.call(this.data, 'callback')) {
                if(typeof this.data.callback === 'function') {
                    this.data.callback(this.$refs.input.value, (this.data.hasOwnProperty.call(this.data, 'parent') ? this.data.parent : 0));
                    this.close();
                }
            }
        }
    },
    mounted() {
        this.$emitter.on('show_add_topic', (data) => {
            this.modal_show = true;
            if(data !== undefined) {
                this.data = data;
            }
            else this.data = '';
        });
    }
}
</script>

<style scoped>
.modal::after {
    background: #000;
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    opacity: 0.5;
}

.modal.show {
    display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.text-primary {
    color: var(--primary-color) !important;
}

.custom-input, .custom-input::placeholder {
    font-size: 14px;
}
</style>